import { render, staticRenderFns } from "./ProjectOccRateReport.vue?vue&type=template&id=0a80b853"
import script from "./ProjectOccRateReport.vue?vue&type=script&lang=js"
export * from "./ProjectOccRateReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports